const getChartColorsArray = (colors = "") => {
    if (!colors) {
      console.error("Colors array is undefined or empty.");
      return [];
    }
  
    // Check if the input is a valid JSON string
    try {
      colors = JSON.parse(colors);
    } catch (e) {
      // If not, assume it's a comma-separated string and split it manually
      colors = colors.split(',').map(color => color.trim());
    }
  
    // Now process the colors array
    return colors.map(function (value) {
      var newValue = value.replace(" ", "");
  
      if (newValue.indexOf(",") === -1) {
        // Check if it's a CSS variable (starts with --) or a named color
        var color = getComputedStyle(document.documentElement).getPropertyValue(newValue);
  
        if (color.indexOf("#") !== -1) {
          color = color.replace(" ", "");
        }
  
        // Return the color or the original value if no CSS variable found
        if (color) return color;
        else return newValue;
  
      } else {
        // Handle RGBA case
        var val = value.split(',');
        if (val.length === 2) {
          var rgbaColor = getComputedStyle(document.documentElement).getPropertyValue(val[0]);
          rgbaColor = "rgba(" + rgbaColor + "," + val[1] + ")";
          return rgbaColor;
        } else {
          return newValue;
        }
      }
    });
  };
  
  export default getChartColorsArray;  